type AvailableRegionNames = 'usEast1' | 'usWest2';

type SuccessResponse = {
  name: AvailableRegionNames;
  success: true;
  idToken: string;
  accessToken: string;
  refreshToken: string;
};

type ErrorResponse = {
  name: AvailableRegionNames;
  success: false;
  error: any;
};

type RegionResponse = SuccessResponse | ErrorResponse;

export const handleCheckIsSuccess = (
  data: RegionResponse[]
): data is SuccessResponse[] => {
  return data.some((region) => !!region.success);
};

export const getErrorFromRegionResponse = (data: RegionResponse[]) => {
  const errors: string[] = [];
  data.forEach((item) => {
    if (!item.success) {
      errors.push(item.error.message);
    }
  });

  return errors;
};
